(function () {
  function wrapTables(root) {
    root.querySelectorAll('.main-page__content table').forEach(function (table) {
      if (table.parentElement.classList.contains('main-page__table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'main-page__table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.main-page').forEach(wrapTables);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var page = event.target.querySelector('.main-page');
    if (page) wrapTables(page);
  });
})();
